import React from 'react';
import FormWithDescription from '../../FormWithDescription';
import ColorPicker from '../ColorPicker';

export default function ColorSchemePicker({ primaryColor, setPrimaryColor }) {
  return (
    <div>
      <FormWithDescription
        title="Color scheme"
        description="Make your blog unique by choosing your own color scheme. Pick a suggested color or choose your own (HEX code). You can change this anytime."
      >
        <ColorPicker color={primaryColor} setColor={setPrimaryColor} />
      </FormWithDescription>
    </div>
  );
}
